import * as React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { LinkIcon, ShareIcon } from '@heroicons/react/20/solid';
import { Button, Grid } from '@nextui-org/react';

interface AppWebShareProps {
  text: string;
  title: string;
  url: string;
}

/**
 * @name AppWebShare
 * @external https://web.dev/web-share/ Share API
 * @external https://developers.google.com/analytics/devguides/collection/ga4/reference/events#share GA Event
 * @description tbd...
 */
export function AppWebShare(props: AppWebShareProps) {
  const { text, title, url } = props;

  // Hooks
  const [isCopied, setIsCopied] = React.useState(false);

  // Setup
  const isAvailable = typeof navigator !== 'undefined' && navigator.share;

  // Handlers
  const onCopied = () => {
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  const onShare = () => {
    navigator.share({
      text,
      title,
      url,
    });
  };

  return (
    <Grid.Container xs gap={1}>
      <Grid xs={12} sm={6}>
        <CopyToClipboard text={url} onCopy={onCopied}>
          <Button
            css={{ w: 'stretch' }}
            icon={<LinkIcon width={20} height={20} />}
          >
            {isCopied ? 'Copied!' : 'Copy Link'}
          </Button>
        </CopyToClipboard>
      </Grid>
      <Grid xs={12} sm={6}>
        {isAvailable && (
          <Button
            css={{ w: 'stretch' }}
            onClick={onShare}
            icon={<ShareIcon width={20} height={20} />}
          >
            Share
          </Button>
        )}
      </Grid>
    </Grid.Container>
  );
}
